import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import './phase8.css'
import './route-loading.css'
import './qa-figma-review.css'
import './qa-order-display.css'
import './overview-money-display.css'
import './public-developer-credit.css'
import './production/contract-flow.css'
import './qa-figma-review'

const root = document.getElementById('root')

if (!root) {
  throw new Error('Root element was not found')
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
